export enum EnvironmentPlatform {
    Web = 'web',
    SDK = 'sdk'    
}
